var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"8","height":"9","viewBox":"0 0 8 9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"4","cy":"4.5","r":"4","fill":"#93959D"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }